import React from 'react';

const TermsAndConditions = () => (
  <div className="max-w-3xl mx-auto pb-12 px-4 pt-32 lg:pt-36">
    <h1 className="text-3xl font-bold mb-6 text-primary">Terms & Conditions</h1>
    <p className="mb-4 text-text-secondary">
      Please read these Terms & Conditions ("Terms", "Terms and Conditions") carefully before using our service.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">1. Acceptance of Terms</h2>
    <p className="mb-4 text-text-secondary">
      By accessing or using our service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the service.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">2. Use of Service</h2>
    <ul className="list-disc ml-6 mb-4 text-text-secondary">
      <li>You must be at least 13 years old to use this service.</li>
      <li>You agree not to misuse the service or help anyone else do so.</li>
      <li>We reserve the right to suspend or terminate your access at any time.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">3. Intellectual Property</h2>
    <p className="mb-4 text-text-secondary">
      The service and its original content, features, and functionality are and will remain the exclusive property of the company and its licensors.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">4. Limitation of Liability</h2>
    <p className="mb-4 text-text-secondary">
      In no event shall the company be liable for any indirect, incidental, special, consequential or punitive damages.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">5. Changes to Terms</h2>
    <p className="mb-4 text-text-secondary">
      We reserve the right to modify or replace these Terms at any time. We will notify users of any significant changes.
    </p>
    <h2 className="text-xl font-semibold mt-8 mb-2">6. Contact Us</h2>
    <p className="text-text-secondary">
      If you have any questions about these Terms, please contact us at <a href="mailto:support@playlistsync.com" className="text-primary underline">support@playlistsync.com</a>.
    </p>
  </div>
);

export default TermsAndConditions; 